import React from "react";
import {FormPageLayout} from "../../components/layout/FormPageLayout";
import {ApplicationDetailFeature} from "../../features/applicationDetail";

const CaseDetailPage = () => (
  <FormPageLayout
    showLeftGoBack
    body={
      <ApplicationDetailFeature/>
    }
  />
);

export default CaseDetailPage;
